import { Text, View, StyleSheet, Image, Dimensions, TouchableOpacity, Animated, ActivityIndicator } from 'react-native'
import theme from '../../../theme'
import { colorText } from '../../../themeConstants'
import { isAndroid } from '../../utils/platformUtils'

const { width, height } = Dimensions.get('window')

const styles3 = StyleSheet.create({
    blockHeader: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
    },
    //Imagen de detalle de beneficios
    imageHeader: {
        width: Dimensions.get('window').width * 0.9,
        aspectRatio: 1,
        borderRadius: 10,
    },
    invisibleContainer: {
        flex: 1,
        flexDirection: 'column',
        position: 'absolute',
        padding: 0,
        top: -10,
        width: width,
        justifyContent: 'center',
    },
    container: {
        flex: 1,
        flexDirection: 'row',
        position: 'absolute',
        top: 58,
        width: width,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.colors.colorPrimary,
        paddingTop: 5,
        paddingBottom: isAndroid() ? 15 : 15,
        zIndex: 1,
    },
    feedbackAssetContainer: {
        width: isAndroid() ? 42 : 42,
        aspectRatio: 1,
        marginRight: 12,
        marginLeft: 12,
        marginTop: 12,
        alignSelf: 'center',
        zIndex: 2,
    },
    feedbackAsset: {
        width: isAndroid() ? 42 : 42,
        flex: 1,
        aspectRatio: 1,
        zIndex: 2,
    },
    containerPoints: {
        borderTopStartRadius: 20,
        borderTopEndRadius: 20,
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        backgroundColor: theme.colors.colorPrimary,
        marginTop: 25,
        marginHorizontal: 0,
        paddingTop: 15,
        paddingBottom: 0,
        zIndex: 1,
    },
    levelKnowledgeBlock: {
        flex: 1,
        marginHorizontal: 0,
        paddingRight: 10,
        zIndex: 1,
    },
    alignStart: {
        alignItems: 'flex-start',
    },
    containerData: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerDataBaseline: {
        flexDirection: 'row',
        alignItems: 'baseline',
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: colorText,
        marginRight: 5,
        marginTop: 5,
    },
    subtitle: {
        fontSize: 13,
        color: colorText,
    },
    value: {
        fontSize: 28,
        fontWeight: 'bold',
        color: colorText,
    },
})

export default styles3
